export default {

  SET_IDOLS_AND_QUOTES(state, list) {
    state.idols = list;
  },

  QUOTES_SAVE_OFFLINE(state) {
    // Using Date here is ok!
    state.idols_last_update = new Date();
    window.localStorage['quotes_data'] = JSON.stringify(state.idols);
    window.localStorage['quotes_last_update'] = state.idols_last_update;
  }
}
